// extracted by mini-css-extract-plugin
export default {"SignUpTitle":"iStyles_SignUpTitle__e6yhO","SignUpSubtitle":"iStyles_SignUpSubtitle__opFGH"};